import { UAParser } from 'ua-parser-js'

const BROWSER_ICONS = {
  Chrome:         '🌐',
  'Mobile Chrome':'🌐',
  Firefox:        '🦊',
  Safari:         '🧭',
  'Mobile Safari':'🧭',
  Edge:           '🔷',
  Opera:          '🔴',
  IE:             '🔵',
  Samsung:        '📱',
  WebView:        '📦',
}

const OS_ICONS = {
  Android:  '🤖',
  iOS:      '🍎',
  Windows:  '🪟',
  macOS:    '🍎',
  Linux:    '🐧',
  Ubuntu:   '🐧',
  ChromeOS: '🌐',
}

function getBrowserIcon(name = '') {
  for (const key of Object.keys(BROWSER_ICONS)) {
    if (name.includes(key)) return BROWSER_ICONS[key]
  }
  return '🌐'
}

function getOsIcon(name = '') {
  for (const key of Object.keys(OS_ICONS)) {
    if (name.includes(key)) return OS_ICONS[key]
  }
  return '💻'
}

export default function UserAgentBadge({ ua }) {
  if (!ua) return <span className="text-gray-400 text-xs">—</span>

  const parser = new UAParser(ua)
  const browser = parser.getBrowser()
  const os = parser.getOS()
  const device = parser.getDevice()

  const browserName = browser.name || 'Desconocido'
  const browserVersion = browser.version ? browser.version.split('.')[0] : ''
  const osName = os.name || ''
  const osVersion = os.version || ''
  const deviceType = device.type || 'desktop'

  const browserIcon = getBrowserIcon(browserName)
  const osIcon = getOsIcon(osName)
  const deviceIcon = deviceType === 'mobile' ? '📱' : deviceType === 'tablet' ? '📟' : '🖥️'

  return (
    <div className="flex items-center gap-1 flex-wrap" title={ua}>
      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-gray-100 rounded text-xs text-gray-700">
        {browserIcon} {browserName} {browserVersion}
      </span>
      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-gray-100 rounded text-xs text-gray-700">
        {osIcon} {osName} {osVersion}
      </span>
      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-gray-100 rounded text-xs text-gray-700">
        {deviceIcon}
      </span>
    </div>
  )
}